import axios from '@/plugins/axios';

export function createByWorkSpace(workSpaceId) {
    return new ContrAgentRpcClient('contr-agents/rpc/work-spaces', workSpaceId)
}

export default class ContrAgentRpcClient{
    constructor(namespace, id) {
        this.namespace = namespace;
        this.id = id;
    }
    async getJurAll(page = 1, per_page = 10, include = []){
        return this.rpc('getJurAll', {page, per_page, include});
    }
    async jurCreate(jurCreateRequest){
        return this.rpc('jurCreate', {jurCreateRequest});
    }
    async jurUpdate(jurId, jurUpdateRequest){
        return this.rpc('jurUpdate', {jurId, jurUpdateRequest});
    }
    async getJurInn(inn,  include = []){
        return this.rpc('getJurInn', {inn, include});
    }
    async jurRemove(jurId){
        return this.rpc('jurRemove', {jurId});
    }
    async prefetch(inn){
        return this.rpc('prefetch', {inn});
    }
    async getContactAll(page = 1, per_page = 10){
        return this.rpc('getContactAll', {page, per_page});
    }
    async getContact(id, include = ''){
        return this.rpc('getContact', {id, include});
    }
    async contactCreate(contactCreateRequest){
        return this.rpc('contactCreate', {contactCreateRequest});
    }
    async contactUpdate(contactId, contactUpdateRequest){
        return this.rpc('contactUpdate', {contactId, contactUpdateRequest});
    }
    async contactRemove(contactId){
        return this.rpc('contactRemove', {contactId});
    }
    async addContactInfo(contactId, addContactInfoRequest){
        return this.rpc('addContactInfo', {contactId, addContactInfoRequest});
    }
    async getJurContacts(jurId, page=1, per_page=10){
        return this.rpc('getJurContacts', {jurId, page, per_page});
    }
    async attachJurContacts(jurId, contactId){
        return this.rpc('attachJurContacts', {jurId, contactId});
    }
    async searchJur(q){
        return this.rpc('searchJur', {q});
    }
    async rpc(method, params){
        return await axios.post(`${this.namespace}/${this.id}`, {method, params});
    }
}